"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapPoints$ = exports.MapPoints$outboundSchema = exports.MapPoints$inboundSchema = void 0;
exports.mapPointsToJSON = mapPointsToJSON;
exports.mapPointsFromJSON = mapPointsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.MapPoints$inboundSchema = z.object({
    building_point: z.nullable(z.string()),
    street_point: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "building_point": "buildingPoint",
        "street_point": "streetPoint",
    });
});
/** @internal */
exports.MapPoints$outboundSchema = z.object({
    buildingPoint: z.nullable(z.string()),
    streetPoint: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        buildingPoint: "building_point",
        streetPoint: "street_point",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var MapPoints$;
(function (MapPoints$) {
    /** @deprecated use `MapPoints$inboundSchema` instead. */
    MapPoints$.inboundSchema = exports.MapPoints$inboundSchema;
    /** @deprecated use `MapPoints$outboundSchema` instead. */
    MapPoints$.outboundSchema = exports.MapPoints$outboundSchema;
})(MapPoints$ || (exports.MapPoints$ = MapPoints$ = {}));
function mapPointsToJSON(mapPoints) {
    return JSON.stringify(exports.MapPoints$outboundSchema.parse(mapPoints));
}
function mapPointsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.MapPoints$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MapPoints' from JSON`);
}
//# sourceMappingURL=mappoints.js.map